import { createColumnHelper } from '@tanstack/react-table';
import { ClientIntegrationDTO } from '../clientIntegration.model';
import {
  SearchFilterOptions,
  StickyOptions
} from 'common/components/table/tableTypes';
import ClientIntegrationTableActions from './client-integration-table-actions';
import { formatIsoDateTimeStringToDisplayDate } from 'common/utils/LEGACY_timeHelpers';
import { multiSelectFilter } from 'common/components/table/table-functions/filters';
import { IntegrationMeta } from 'features/client-integrations/clientIntegration-meta-slice';

const columnHelper = createColumnHelper<ClientIntegrationDTO>();

export const getSegmentationRulesColumnDefs = (
  integrationMetaMap: Record<string, IntegrationMeta>
) => [
  columnHelper.accessor((row) => row.platform, {
    id: 'Platform',
    header: () => 'Platform',
    enableColumnFilter: true,
    filterFn: multiSelectFilter,
    meta: {
      searchFilterOptions: {
        isEnabled: true
      } as SearchFilterOptions
    },
    cell: (info) => {
      const platform = info.getValue<string>();
      const integrationMeta = integrationMetaMap[platform];

      if (!integrationMeta) {
        const fallbackName = platform.replace(/(Ads)/, ' $1');
        return <div className="text-sm font-bold truncate">{fallbackName}</div>;
      }

      return (
        <div className="flex items-center gap-2 text-sm font-bold truncate">
          <img
            src={integrationMeta.logo}
            alt={integrationMeta.name}
            className="h-5 w-5 object-contain"
          />
          <span>{integrationMeta.name}</span>
        </div>
      );
    }
  }),
  columnHelper.accessor((row) => row.platformCategory, {
    id: 'Category',
    header: () => 'Category',
    enableColumnFilter: true,
    filterFn: multiSelectFilter,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.state, {
    id: 'Status',
    header: () => 'Status',
    enableColumnFilter: true,
    filterFn: multiSelectFilter,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.createdDateTime, {
    id: 'CreatedDate',
    header: () => 'Created Date',
    enableColumnFilter: false,
    cell: (info) => (
      <div className="text-sm truncate">
        {formatIsoDateTimeStringToDisplayDate(info.getValue())}
      </div>
    )
  }),
  columnHelper.accessor((row) => row.createdBy, {
    id: 'CreatedBy',
    header: () => 'Created By',
    enableColumnFilter: false,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.updatedDateTime, {
    id: 'UpdatedDate',
    header: () => 'Updated Date',
    enableColumnFilter: false,
    cell: (info) => (
      <div className="text-sm truncate">
        {formatIsoDateTimeStringToDisplayDate(info.getValue())}
      </div>
    )
  }),
  columnHelper.accessor((row) => row.updatedBy, {
    id: 'UpdatedBy',
    header: () => 'Updated By',
    enableColumnFilter: false,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.dataSource, {
    id: 'Options',
    header: () => 'Options',
    enableColumnFilter: false,
    cell: (info) => (
      <ClientIntegrationTableActions clientIntegration={info.row.original} />
    ),
    minSize: 75,
    maxSize: 75,
    meta: {
      stickyOptions: {
        isEnabled: true,
        side: 'right'
      } as StickyOptions
    }
  })
];
